(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kroq-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaq(root) {
      if (root.dataset.kroqFaqInit) return;
      root.dataset.kroqFaqInit = '1';
      var input = root.querySelector('[data-kroq-faq-search]');
      if (!input) return;
      var items = root.querySelectorAll('[data-kroq-faq-item]');
      var empty = root.querySelector('[data-kroq-faq-empty]');
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        var visible = 0;
        items.forEach(function (item) {
          var match = item.textContent.toLowerCase().indexOf(q) !== -1;
          item.hidden = q && !match;
          if (!item.hidden) visible++;
        });
        if (empty) empty.hidden = visible !== 0;
      });
    }
    function boot() { document.querySelectorAll('.kroq-faq').forEach(initFaq); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kroq-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initProduct(root) {
      if (root.dataset.kroqInit) return;
      root.dataset.kroqInit = '1';

      var form = root.querySelector('[data-kroq-form]');
      var mainImg = root.querySelector('[data-kroq-main-image]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-kroq-thumb]'));
      var status = root.querySelector('[data-kroq-status]');

      function announce(message, state) {
        if (!status) return;
        status.textContent = message || '';
        if (state) {
          status.setAttribute('data-state', state);
        } else {
          status.removeAttribute('data-state');
        }
      }

      function activateThumb(thumb) {
        if (!thumb) return;
        if (mainImg && thumb.dataset.full) {
          mainImg.removeAttribute('srcset');
          mainImg.src = thumb.dataset.full;
        }
        thumbs.forEach(function (t) {
          var active = t === thumb;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          activateThumb(thumb);
        });
      });

      /* ── Quantité ── */
      var qtyWrap = root.querySelector('[data-kroq-qty]');
      if (qtyWrap) {
        var qtyInput = qtyWrap.querySelector('input');
        var minus = qtyWrap.querySelector('[data-kroq-qty-minus]');
        var plus = qtyWrap.querySelector('[data-kroq-qty-plus]');
        if (minus) {
          minus.addEventListener('click', function () {
            qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
          });
        }
        if (plus) {
          plus.addEventListener('click', function () {
            qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
          });
        }
      }

      /* ── Variantes ──
         Les libellés monétaires viennent de Liquid : aucun formatage de prix
         n'est fait ici, ce qui garantit la bonne devise sur tous les marchés. */
      var variants = [];
      var variantsTag = root.querySelector('[data-kroq-variants]');
      if (variantsTag) {
        try {
          variants = JSON.parse(variantsTag.textContent);
        } catch (e) {
          variants = [];
        }
      }

      var idInput = root.querySelector('[data-kroq-variant-id]');
      var priceEl = root.querySelector('[data-kroq-price-amount]');
      var compareEl = root.querySelector('[data-kroq-price-compare]');
      var priceRoot = root.querySelector('[data-kroq-price-root]');
      var atc = root.querySelector('[data-kroq-atc]');
      var atcLabel = root.querySelector('[data-kroq-atc-label]');
      var buynow = root.querySelector('[data-kroq-buynow]');
      var stickyPrice = root.querySelector('[data-kroq-sticky-price]');

      /* Les deux libellés viennent des attributs traduits : les lire dans le
         DOM donnerait « Indisponible » comme libellé d'ajout sur un produit
         initialement épuisé. */
      var LABEL_ADD = root.dataset.kroqLabelAdd || '';
      var LABEL_UNAVAILABLE = root.dataset.kroqLabelUnavailable || '';

      function getSelectedOptions() {
        var opts = [];
        root.querySelectorAll('[data-kroq-option]').forEach(function (input) {
          if (input.checked) opts[parseInt(input.dataset.kroqOption, 10) - 1] = input.value;
        });
        return opts;
      }

      function matchVariant(opts) {
        return variants.filter(function (v) {
          return v.options.every(function (o, i) {
            return o === opts[i];
          });
        })[0];
      }

      function updateVariant() {
        if (!variants.length) return;
        var opts = getSelectedOptions();
        var v = opts.length ? matchVariant(opts) : variants[0];
        if (!v) return;

        if (idInput) idInput.value = v.id;

        /* Prix : on remplace uniquement le nœud texte, en préservant le
           libellé lecteur d'écran rendu par le composant kroq-price. */
        if (priceEl) {
          var srLabel = priceEl.querySelector('.visually-hidden');
          priceEl.textContent = v.price;
          if (srLabel) {
            if (priceRoot) {
              srLabel.textContent = v.compare_at_price
                ? priceRoot.dataset.labelSale || ''
                : priceRoot.dataset.labelRegular || '';
            }
            priceEl.insertBefore(srLabel, priceEl.firstChild);
          }
        }
        if (stickyPrice) stickyPrice.textContent = v.price;

        if (compareEl) {
          if (v.compare_at_price) {
            compareEl.hidden = false;
            compareEl.innerHTML = '';
            var s = document.createElement('s');
            s.textContent = v.compare_at_price;
            compareEl.appendChild(s);
          } else {
            compareEl.hidden = true;
            compareEl.textContent = '';
          }
        }
        if (priceRoot) priceRoot.classList.toggle('kroq-price--on-sale', !!v.compare_at_price);

        [atc, buynow].forEach(function (btn) {
          if (btn) btn.disabled = !v.available;
        });
        if (atcLabel) atcLabel.textContent = v.available ? LABEL_ADD : LABEL_UNAVAILABLE;

        /* Média de la variante, quand elle en a un. */
        if (v.media_id) {
          var thumb = thumbs.filter(function (t) {
            return String(t.dataset.mediaId) === String(v.media_id);
          })[0];
          if (thumb) {
            activateThumb(thumb);
          } else if (mainImg && v.image) {
            mainImg.removeAttribute('srcset');
            mainImg.src = v.image;
          }
        }

        /* L'URL reflète la variante choisie : lien partageable et retour
           arrière cohérent, sans rechargement. */
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      root.querySelectorAll('[data-kroq-option]').forEach(function (input) {
        input.addEventListener('change', updateVariant);
      });

      /* ── Ajout au panier ── */
      function refreshCartEvent(button, didError) {
        return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
          headers: { Accept: 'application/json' },
        })
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .then(function (cart) {
            (button || document).dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: cart,
                  sourceId: 'kroq-pdp',
                  data: { source: 'kroq-pdp', itemCount: cart ? cart.item_count : 0, didError: !!didError },
                },
              })
            );
          })
          .catch(function () {});
      }

      function ajaxAdd() {
        return fetch(form.action, {
          method: 'POST',
          headers: { Accept: 'application/javascript' },
          body: new FormData(form),
        }).then(function (r) {
          return r.json().then(function (body) {
            if (!r.ok) throw new Error(body && body.description ? body.description : 'add failed');
            return body;
          });
        });
      }

      /* Une seule requête d'ajout à la fois, quel que soit le bouton.

         Le bouton principal se verrouillait déjà pendant l'appel, mais la
         barre flottante appelle `form.requestSubmit()`, qui soumet le
         formulaire sans regarder l'état du bouton de soumission. Trois tapes
         rapides sur la barre envoyaient donc trois POST : le panier passait à
         3 alors que le client croyait ajouter un article. Le drapeau est
         partagé par les trois chemins d'ajout. */
      var adding = false;
      var addButtons = [];

      function lockAdd(state) {
        adding = state;
        addButtons.forEach(function (b) {
          if (b) b.disabled = state;
        });
      }

      if (atc) addButtons.push(atc);
      if (buynow) addButtons.push(buynow);

      if (form) {
        form.addEventListener('submit', function (e) {
          /* Amélioration progressive : sans JS, le POST natif fonctionne. */
          e.preventDefault();
          if (adding) return;
          lockAdd(true);
          announce('');
          ajaxAdd()
            .then(function () {
              announce(root.dataset.kroqLabelAdded || '', 'success');
              return refreshCartEvent(atc, false);
            })
            .catch(function (err) {
              announce(err.message || root.dataset.kroqLabelError || '', 'error');
            })
            .finally(function () {
              lockAdd(false);
            });
        });
      }

      if (buynow) {
        buynow.addEventListener('click', function () {
          if (adding) return;
          lockAdd(true);
          ajaxAdd()
            .then(function () {
              window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'checkout';
            })
            .catch(function (err) {
              announce(err.message || root.dataset.kroqLabelError || '', 'error');
              lockAdd(false);
            });
        });
      }

      /* ── Barre flottante ── */
      var sticky = root.querySelector('[data-kroq-sticky]');
      if (sticky && atc && 'IntersectionObserver' in window) {
        var stickyAdd = sticky.querySelector('[data-kroq-sticky-add]');
        if (stickyAdd && form) {
          addButtons.push(stickyAdd);
          stickyAdd.addEventListener('click', function () {
            if (adding) return;
            if (form.requestSubmit) {
              form.requestSubmit();
            } else {
              form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
            }
          });
        }
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var show = !entry.isIntersecting;
              /* `hidden` retire réellement la barre de l'arbre d'accessibilité
                 quand elle est repliée, et la restitue quand elle est visible. */
              if (show) {
                sticky.hidden = false;
                requestAnimationFrame(function () {
                  sticky.classList.add('is-visible');
                });
              } else {
                sticky.classList.remove('is-visible');
                sticky.hidden = true;
              }
            });
          },
          { rootMargin: '0px 0px -100% 0px' }
        );
        io.observe(atc);
      }

      /* ── Guide des tailles ── */
      var sizer = root.querySelector('[data-kroq-sizer]');
      if (sizer) {
        var SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL'];

        /* Seuils lus depuis le schema de la section : « XS:5,S:10,M:20,L:35 ».
           Au-delà du dernier seuil, la taille suivante s'applique. */
        var thresholds = [];
        (sizer.dataset.kroqThresholds || root.dataset.kroqThresholds || 'XS:5,S:10,M:20,L:35')
          .split(',')
          .forEach(function (pair) {
            var bits = pair.split(':');
            if (bits.length === 2 && !isNaN(parseFloat(bits[1]))) {
              thresholds.push({ code: bits[0].trim().toUpperCase(), max: parseFloat(bits[1]) });
            }
          });

        function sizeFromWeight(kg) {
          if (!(kg > 0)) return null;
          for (var i = 0; i < thresholds.length; i++) {
            if (kg <= thresholds[i].max) return thresholds[i].code;
          }
          return SIZE_ORDER[SIZE_ORDER.length - 1];
        }

        /* Tailles réellement proposées par CE produit. */
        var offered = [];
        var valueByCode = {};
        (sizer.getAttribute('data-sizes') || '').split('||').forEach(function (label) {
          var u = (label || '').toUpperCase().trim();
          if (!u) return;
          SIZE_ORDER.forEach(function (code) {
            var re = new RegExp('(^|[^A-Z])' + code + '([^A-Z]|$)');
            if (re.test(u) && offered.indexOf(code) === -1) {
              offered.push(code);
              valueByCode[code] = label.trim();
            }
          });
        });

        var resultEl = sizer.querySelector('[data-kroq-sizer-result]');
        var breedSel = sizer.querySelector('[data-kroq-breed]');
        var weightInput = sizer.querySelector('[data-kroq-sizer-weight]');

        function selectVariantForCode(code) {
          var label = valueByCode[code];
          if (!label) return false;
          var matched = false;
          root.querySelectorAll('[data-kroq-option]').forEach(function (input) {
            if (!matched && input.value === label) {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
              matched = true;
            }
          });
          return matched;
        }

        /* Rendu par nœuds DOM (pas d'innerHTML) : aucune donnée n'est
           interprétée comme du HTML. */
        function render(code) {
          if (!resultEl) return;
          resultEl.textContent = '';
          if (!code) {
            var ph = document.createElement('span');
            ph.className = 'kroq-sizer__placeholder';
            ph.textContent = sizer.dataset.labelPlaceholder || '';
            resultEl.appendChild(ph);
            return;
          }

          var isOffered = offered.length === 0 || offered.indexOf(code) !== -1;
          var template;
          var cls = 'is-ok';
          if (offered.length === 0) {
            template = sizer.dataset.labelSingle || '';
          } else if (isOffered) {
            template = selectVariantForCode(code)
              ? sizer.dataset.labelSelected || ''
              : sizer.dataset.labelAvailable || '';
          } else {
            template = sizer.dataset.labelUnavailable || '';
            cls = 'is-warn';
          }

          var badge = document.createElement('div');
          badge.className = 'kroq-sizer__badge';
          badge.textContent = code;

          var msg = document.createElement('div');
          msg.className = 'kroq-sizer__msg ' + cls;
          msg.textContent = template.replace('%size%', code);

          resultEl.appendChild(badge);
          resultEl.appendChild(msg);
        }

        var tabs = Array.prototype.slice.call(sizer.querySelectorAll('[data-kroq-mode]'));
        function selectTab(btn) {
          var mode = btn.getAttribute('data-kroq-mode');
          tabs.forEach(function (b) {
            var active = b === btn;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-selected', active ? 'true' : 'false');
            b.tabIndex = active ? 0 : -1;
          });
          sizer.querySelectorAll('[data-kroq-pane]').forEach(function (p) {
            p.hidden = p.getAttribute('data-kroq-pane') !== mode;
          });
        }

        tabs.forEach(function (btn, index) {
          btn.addEventListener('click', function () {
            selectTab(btn);
          });
          /* Navigation clavier attendue d'un tablist (WAI-ARIA). */
          btn.addEventListener('keydown', function (e) {
            var next = null;
            if (e.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
            if (e.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
            if (e.key === 'Home') next = tabs[0];
            if (e.key === 'End') next = tabs[tabs.length - 1];
            if (next) {
              e.preventDefault();
              selectTab(next);
              next.focus();
            }
          });
        });

        if (breedSel) {
          breedSel.addEventListener('change', function () {
            render(sizeFromWeight(parseFloat(breedSel.value)));
          });
        }
        if (weightInput) {
          weightInput.addEventListener('input', function () {
            render(sizeFromWeight(parseFloat(weightInput.value)));
          });
        }
      }
    }

    function boot() {
      document.querySelectorAll('[data-kroq-product]').forEach(initProduct);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
